import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../components/login/service/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { NotifierService } from '../../../services/Notifierservice';
import { LoadingService } from './service/loading.service';
import { Observable } from 'rxjs';
@Component({
  standalone: false,
  selector: 'app-main',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './main.component.html',
})
export class MainComponent implements OnInit {
  loading$: Observable<boolean>;
  userDetails: any;
  dateTime: any = new Date();
  private readonly notifier: NotifierService;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly service: LoginService,
    private readonly router: Router,
    private readonly notifierService: NotifierService,
    private readonly loadingService: LoadingService,
  ) {
    this.notifier = this.notifierService;
    this.loading$ = this.loadingService.loading$;
  }
  ngOnInit() {
    if (!localStorage.getItem('user')) {
      this.getUser();
    }
  }

  getUser() {
    this.service.getUser().subscribe({
      next: (response: any) => {
        // ✅ Validate new structure (was 'userid' check, now 'id' + is_active)
        if (!response?.id || !response?.is_active) {
          localStorage.clear();
          sessionStorage.clear();
          this.router.navigateByUrl('login');
          return;
        }

        this.userDetails = response;
        this.service.userDetails = response;

        // ✅ Encrypt with new salt::iv::cipher format
        const userSalt = CryptoJS.lib.WordArray.random(16);
        const userIv = CryptoJS.lib.WordArray.random(16);
        const userKey = CryptoJS.PBKDF2(this.service.enCryptKey, userSalt, {
          keySize: 32,
          iterations: 128,
          hasher: CryptoJS.algo.SHA256,
        });
        const encryptedUser = CryptoJS.AES.encrypt(
          JSON.stringify(response),
          userKey,
          { iv: userIv },
        );
        const storedUser =
          userSalt.toString() +
          '::' +
          userIv.toString() +
          '::' +
          encryptedUser.toString();
        localStorage.setItem('user', storedUser);

        // ✅ Removed plan_id / end_date routing — route based on assigned apps
        if (response.apps && response.apps.length > 0) {
          this.router.navigate(['/main/dashboard']);
        } else {
          this.notifier.notify(
            'default',
            'No applications assigned to your account.',
          );
          this.router.navigate(['/main/dashboard']);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.notifier.notify(
          'error',
          error.error?.['message'] || 'Something went wrong.',
        );
      },
    });
  }
}
